import { Directive, Input } from '@angular/core';

// tslint:disable:use-host-property-decorator
// tslint:disable:no-input-rename
@Directive({
    selector: '[inputLimiter]',
    host: {
        '(keypress)': '_onKeypress($event)',
    }
})
export class InputLimiterDirective {
    @Input('limit-to-length') public limitLength;
    @Input('limit-to-type') public limitTo; // alphanum // numbers

    public notANumber = new RegExp('([^0-9])+');

    public _onKeypress(e) {
        if ((e.key as string).length > 1) {
            return;
        }

        const limit = +this.limitLength;
        if (e.target.value.length >= limit) {
            e.preventDefault();
        } else if (this.limitTo === 'number') {
            const matches = (e.key as string).match(this.notANumber);
            if (matches !== null && matches.length > 0) {
                e.preventDefault();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/features/shared/directives/input-limiter.directive.ts